




export function phoneNumber(phoneNumber) {
  if (typeof(phoneNumber) !== 'string') {
    return('');
  }

  let match = phoneNumber.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return('(' + match[1] + ') ' + match[2] + '-' + match[3]);
  }
  return(phoneNumber);
}
